/**
 * Topo Nomad — "Frame Your Trek" template: LADAKH
 * Applied from template-tuner/exports/tn-template-ladakh.json on 2026-07-02
 * All positions are mm on a 300 x 400 mm artboard.
 * To adjust positions: open template-tuner/index.html, tune, re-export.
 */
(function () {
  'use strict';
  var TN = (window.TopoNomadEditor = window.TopoNomadEditor || {});
  TN._templates = TN._templates || {};
  TN.registerTemplate = TN.registerTemplate || function (tpl) { TN._templates[tpl.id] = tpl; };

  TN.registerTemplate({
    "schema_version": "1.0",
    "id": "ladakh",
    "name": "Ladakh — Land of High Passes",
    "artboard": {
      "width": 300,
      "height": 400,
      "unit": "mm"
    },
    "print": {
      "min_dpi": 150,
      "block_below_px": [
        1200,
        1600
      ],
      "warn_below_px": [
        1800,
        2400
      ]
    },
    "fonts": {
      "display": {
        "family": "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
        "weight": 600
      },
      "label": {
        "family": "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
        "weight": 500
      },
      "value": {
        "family": "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
        "weight": 400
      }
    },
    "ink": "#FFFFFF",
    "overlay": {
      "max_opacity": 0.7,
      "default_opacity": 0.35,
      "default_tint": "navy",
      "default_gradient": true,
      "tints": [
        {
          "id": "navy",
          "label": "Deep Navy",
          "color": "#12293C"
        },
        {
          "id": "charcoal",
          "label": "Charcoal",
          "color": "#141414"
        },
        {
          "id": "ember",
          "label": "Ember",
          "color": "#3B2418"
        },
        {
          "id": "forest",
          "label": "Forest",
          "color": "#1C3126"
        }
      ]
    },
    "route_map": {
      "mode": "placeholder",
      "box": {
        "x": 35,
        "y": 70,
        "w": 234,
        "h": 230
      },
      "note": "Our designers will hand-draw and highlight your exact route after checkout."
    },
    "groups": [
      {
        "id": "basics",
        "label": "Trip basics",
        "hint": "Where you went and what you call the trip."
      },
      {
        "id": "stats",
        "label": "Stats",
        "hint": "The numbers that made it epic."
      },
      {
        "id": "memories",
        "label": "Memories",
        "hint": "The details you never want to forget."
      },
      {
        "id": "photo",
        "label": "Photo & style",
        "hint": "Your hero shot and the poster mood."
      }
    ],
    "fields": [
      {
        "id": "intro",
        "group": "basics",
        "label": "Intro line",
        "default": "I WENT TO",
        "max_chars": 20,
        "max_lines": 1,
        "transform": "upper",
        "box": {
          "x": 17.8,
          "y": 12,
          "w": 160,
          "h": 8
        },
        "align": "left",
        "font": "value",
        "weight": 400,
        "size": 5.6,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.26
      },
      {
        "id": "destination",
        "group": "basics",
        "label": "Destination",
        "help": "The big one. Keep it short — it shrinks after 8 characters.",
        "default": "LADAKH",
        "max_chars": 14,
        "max_lines": 1,
        "transform": "upper",
        "box": {
          "x": 17,
          "y": 21,
          "w": 266,
          "h": 27
        },
        "align": "left",
        "font": "display",
        "weight": 600,
        "size": 29,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.03
      },
      {
        "id": "subtitle",
        "group": "basics",
        "label": "Subtitle",
        "default": "LAND OF HIGH PASSES",
        "max_chars": 32,
        "max_lines": 1,
        "transform": "upper",
        "box": {
          "x": 18,
          "y": 47.5,
          "w": 220,
          "h": 8
        },
        "align": "left",
        "font": "value",
        "weight": 400,
        "size": 5.8,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.28
      },
      {
        "id": "altitude",
        "group": "stats",
        "label": "Altitude",
        "default": "19,024 ft",
        "max_chars": 12,
        "max_lines": 1,
        "transform": "none",
        "box": {
          "x": 180,
          "y": 23.5,
          "w": 103,
          "h": 7
        },
        "align": "right",
        "font": "value",
        "weight": 400,
        "size": 5,
        "shrink": [
          1,
          0.85
        ],
        "tracking": 0.06
      },
      {
        "id": "coordinates",
        "group": "stats",
        "label": "Coordinates",
        "help": "Auto-filled for destinations we know.",
        "default": "34.22° N, 77.56° E",
        "max_chars": 24,
        "max_lines": 1,
        "transform": "none",
        "box": {
          "x": 160,
          "y": 50.5,
          "w": 123,
          "h": 7
        },
        "align": "right",
        "font": "value",
        "weight": 400,
        "size": 5,
        "shrink": [
          1,
          0.85
        ],
        "tracking": 0.06
      },
      {
        "id": "trip_label",
        "group": "basics",
        "label": "Trip label",
        "default": "BEST BIKE TRIP",
        "max_chars": 24,
        "max_lines": 1,
        "transform": "upper",
        "box": {
          "x": 132.5,
          "y": 307.5,
          "w": 145,
          "h": 8
        },
        "align": "left",
        "font": "label",
        "weight": 500,
        "size": 6.4,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.16
      },
      {
        "id": "region",
        "group": "basics",
        "label": "Region",
        "default": "REGION : LADAKH",
        "max_chars": 24,
        "max_lines": 1,
        "transform": "upper",
        "box": {
          "x": 183.5,
          "y": 320.5,
          "w": 96,
          "h": 7
        },
        "align": "left",
        "font": "label",
        "weight": 500,
        "size": 5.4,
        "shrink": [
          1,
          0.85
        ],
        "tracking": 0.12
      },
      {
        "id": "rating",
        "group": "stats",
        "label": "Trip rating",
        "widget": "stars",
        "default": 5,
        "no_render": true
      },
      {
        "id": "dates_start",
        "group": "basics",
        "label": "Trip start",
        "default": "JUNE 18",
        "max_chars": 12,
        "max_lines": 1,
        "transform": "upper",
        "row": "dates",
        "box": {
          "x": 98.9,
          "y": 339.6,
          "w": 34,
          "h": 6.5
        },
        "align": "left",
        "font": "value",
        "weight": 400,
        "size": 5.4,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.06
      },
      {
        "id": "dates_end",
        "group": "basics",
        "label": "Trip end",
        "default": "JUNE 30",
        "max_chars": 12,
        "max_lines": 1,
        "transform": "upper",
        "row": "dates",
        "box": {
          "x": 98.5,
          "y": 352,
          "w": 34,
          "h": 6.5
        },
        "align": "left",
        "font": "value",
        "weight": 400,
        "size": 5.4,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.06
      },
      {
        "id": "dates_year",
        "group": "basics",
        "label": "Year",
        "default": "2024",
        "max_chars": 4,
        "max_lines": 1,
        "transform": "upper",
        "row": "dates",
        "box": {
          "x": 98.5,
          "y": 363,
          "w": 34,
          "h": 8
        },
        "align": "left",
        "font": "display",
        "weight": 600,
        "size": 7,
        "shrink": [
          1,
          0.85
        ],
        "tracking": 0.04
      },
      {
        "id": "weather",
        "group": "stats",
        "label": "Weather",
        "default": "Perfect",
        "max_chars": 16,
        "max_lines": 1,
        "transform": "none",
        "box": {
          "x": 32,
          "y": 364.5,
          "w": 51,
          "h": 7
        },
        "align": "center",
        "font": "display",
        "weight": 600,
        "size": 5.8,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.02
      },
      {
        "id": "distance",
        "group": "stats",
        "label": "Distance",
        "default": "1200 KM",
        "max_chars": 10,
        "max_lines": 1,
        "transform": "upper",
        "box": {
          "x": 143,
          "y": 358,
          "w": 62,
          "h": 9
        },
        "align": "left",
        "font": "display",
        "weight": 700,
        "size": 8,
        "shrink": [
          1,
          0.85
        ],
        "tracking": 0.04
      },
      {
        "id": "i_ate",
        "group": "memories",
        "label": "I ate",
        "default": "Good food",
        "max_chars": 40,
        "max_lines": 2,
        "transform": "none",
        "box": {
          "x": 30.6,
          "y": 389,
          "w": 52,
          "h": 8.5
        },
        "align": "center",
        "font": "value",
        "weight": 400,
        "size": 5.2,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.02,
        "line_height": 1.2
      },
      {
        "id": "i_stayed_at",
        "group": "memories",
        "label": "I stayed at",
        "default": "Hotel, Camps",
        "max_chars": 40,
        "max_lines": 2,
        "transform": "none",
        "box": {
          "x": 84,
          "y": 389,
          "w": 52,
          "h": 8.5
        },
        "align": "center",
        "font": "value",
        "weight": 400,
        "size": 5.2,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.02,
        "line_height": 1.2
      },
      {
        "id": "never_forget",
        "group": "memories",
        "label": "I will never forget",
        "default": "Pangong Lake",
        "max_chars": 40,
        "max_lines": 2,
        "transform": "none",
        "box": {
          "x": 147,
          "y": 389,
          "w": 56,
          "h": 8.5
        },
        "align": "center",
        "font": "value",
        "weight": 400,
        "size": 5.2,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.02,
        "line_height": 1.2
      },
      {
        "id": "vehicle",
        "group": "memories",
        "label": "Vehicle used",
        "default": "RE Himalayan 400 CC",
        "max_chars": 40,
        "max_lines": 2,
        "transform": "none",
        "box": {
          "x": 212,
          "y": 389,
          "w": 62,
          "h": 8.5
        },
        "align": "center",
        "font": "value",
        "weight": 400,
        "size": 5.2,
        "shrink": [
          1,
          0.85,
          0.7
        ],
        "tracking": 0.02,
        "line_height": 1.2
      }
    ],
    "fixed": [
      {
        "type": "line",
        "x1": 20.2,
        "y1": 158,
        "x2": 20.2,
        "y2": 310,
        "w": 0.5
      },
      {
        "type": "line",
        "x1": 282.6,
        "y1": 163,
        "x2": 282.6,
        "y2": 348,
        "w": 0.5
      },
      {
        "type": "logo-vertical",
        "x": 20.2,
        "y": 334,
        "size": 3.1,
        "icon_y": 317
      },
      {
        "type": "line",
        "x1": 87.4,
        "y1": 330.5,
        "x2": 87.4,
        "y2": 371.5,
        "w": 0.4
      },
      {
        "type": "line",
        "x1": 135.1,
        "y1": 330.5,
        "x2": 135.1,
        "y2": 371.5,
        "w": 0.4
      },
      {
        "type": "icon",
        "icon": "weather",
        "x": 58.9,
        "y": 335.3,
        "size": 20
      },
      {
        "type": "text",
        "text": "THE WEATHER",
        "x": 57.5,
        "y": 352.5,
        "size": 5.5,
        "align": "center",
        "tracking": 0.1,
        "font": "value",
        "weight": 400
      },
      {
        "type": "text",
        "text": "DISTANCE COVERED",
        "x": 143,
        "y": 341.5,
        "size": 5.5,
        "align": "left",
        "tracking": 0.06,
        "font": "label",
        "weight": 500
      },
      {
        "type": "text",
        "text": "MY TRIP RATING",
        "x": 218,
        "y": 338,
        "size": 5.5,
        "align": "left",
        "tracking": 0.06,
        "font": "label",
        "weight": 500
      },
      {
        "type": "stars",
        "field": "rating",
        "cx": 245,
        "y": 349.5,
        "size": 8,
        "gap": 2.8
      },
      {
        "type": "line",
        "x1": 34.8,
        "y1": 375.6,
        "x2": 280.2,
        "y2": 375.6,
        "w": 0.5
      },
      {
        "type": "text",
        "text": "I ATE",
        "x": 56.6,
        "y": 379,
        "size": 5.4,
        "align": "center",
        "tracking": 0.1,
        "font": "label",
        "weight": 500
      },
      {
        "type": "text",
        "text": "I STAYED AT",
        "x": 110.2,
        "y": 379,
        "size": 5.4,
        "align": "center",
        "tracking": 0.1,
        "font": "label",
        "weight": 500
      },
      {
        "type": "text",
        "text": "I WILL NEVER FORGET",
        "x": 175,
        "y": 379,
        "size": 5.4,
        "align": "center",
        "tracking": 0.1,
        "font": "label",
        "weight": 500
      },
      {
        "type": "text",
        "text": "VEHICLE USED",
        "x": 242.7,
        "y": 379,
        "size": 5.4,
        "align": "center",
        "tracking": 0.1,
        "font": "label",
        "weight": 500
      }
    ],
    "suggest": {
      "LADAKH": {
        "subtitle": "LAND OF HIGH PASSES",
        "altitude": "19,024 ft",
        "coordinates": "34.22° N, 77.56° E"
      },
      "LEH": {
        "subtitle": "LAND OF HIGH PASSES",
        "altitude": "11,562 ft",
        "coordinates": "34.16° N, 77.58° E"
      },
      "SPITI": {
        "subtitle": "THE MIDDLE LAND",
        "altitude": "13,123 ft",
        "coordinates": "32.25° N, 78.03° E"
      },
      "SPITI VALLEY": {
        "subtitle": "THE MIDDLE LAND",
        "altitude": "13,123 ft",
        "coordinates": "32.25° N, 78.03° E"
      },
      "MANALI": {
        "subtitle": "VALLEY OF THE GODS",
        "altitude": "6,726 ft",
        "coordinates": "32.24° N, 77.19° E"
      },
      "EVEREST BASE CAMP": {
        "subtitle": "TOP OF THE WORLD",
        "altitude": "17,598 ft",
        "coordinates": "28.00° N, 86.86° E"
      },
      "ZANSKAR": {
        "subtitle": "THE COPPER VALLEY",
        "altitude": "13,154 ft",
        "coordinates": "33.51° N, 76.89° E"
      }
    }
  });
})();
